<template>
  <span class="rounded-full bg-blue-600 px-1.5 py-px text-[9px] font-bold uppercase tracking-wide text-white">{{ label }}</span>
</template>

<script setup lang="ts">
  // Marks the column the user is standing in. Shared so the scheduling board and the capacity
  // calendar mark it identically; the wording follows whatever the columns are.
  withDefaults(defineProps<{ label?: string }>(), { label: 'This week' });
</script>
